export const grooveType = {
    "SIDE": "Торцевой",
    "SIMPLE_BLIND": "Простой несквозной",
    "SIMPLE_THROUGH": "Простой сквозной",
    "COMPLEX_BLIND": "Простой несквозной",
    "COMPLEX_THROUGH": "Сложный сквозной",
    "ANY": "Не определеной",
}